import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  InputGroup,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { api } from "../../api";
import { toast } from "react-toastify";

interface ChangePasswordDialogProps {
  onClose: () => void;
}

interface ChangePasswordDialogState {
}

@observer
export class ChangePasswordDialog
  extends React.Component<ChangePasswordDialogProps, ChangePasswordDialogState> {

  obs = observable({
    focusDone: false as boolean,
    currentPassword: "" as string,
    newPassword: "" as string,
    working: false as boolean

  })
  focusFirst(el: HTMLInputElement) {
    if (!this.obs.focusDone) {
      el.focus();
      this.obs.focusDone = true;
    }
  }

  handleChangePassword = async () => {
    try {
      this.obs.working = true;
      let resp = await api.post("/api/me/password", {
        current_password: this.obs.currentPassword,
        new_password: this.obs.newPassword,
      });
      if (resp.data.ok) {
        toast.success('Senha alterada com sucesso', {});
        this.props.onClose();
      } else {
        toast.error(`Erro ao alterar senha: ${resp.data.msg}`, {});
      }

    } catch (ex) {
      toast.error('Erro alterando a senha, tente novamente mais tarde.', {});
    } finally {
      this.obs.working = false;
    }
  };

  render() {
    let newPasswordValid = this.obs.newPassword.length > 6;
    let valid = newPasswordValid && this.obs.currentPassword;

    return (
      <Dialog isOpen title="Editar Senha" onClose={this.props.onClose}>
        <div className={Classes.DIALOG_BODY}>

          <FormGroup
            label="Senha atual"
            labelInfo="(obrigatório)"
            helperText="Preencha a sua senha atual."
          >
            <InputGroup
              name='new-current-password'
              autoComplete='new-current-password'
              type="password"
              inputRef={(el: any) => this.focusFirst(el)}
              value={this.obs.currentPassword}
              onChange={(e: any) => this.obs.currentPassword = e.target.value}
            />
          </FormGroup>

          <FormGroup
            label="Nova senha"
            labelInfo="(obrigatório)"
            helperText="Escolhe uma senha nova. A senha deve ser de pelo menos 6 caracteres, contendo letras e números."
          >
            <InputGroup
              name='new-password'
              autoComplete='new-password'
              value={this.obs.newPassword}
              type="password"
              onChange={(e: any) => this.obs.newPassword = e.target.value}
            />
          </FormGroup>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              text="Cancelar"
              onClick={this.props.onClose}
              disabled={this.obs.working}
            />
            <Button
              text="Salvar"
              disabled={!valid}
              intent="primary"
              onClick={this.handleChangePassword}
              loading={this.obs.working}
            />
          </div>
        </div>
      </Dialog>
    );
  }
}
